export default "__VITE_ASSET__BngZ1xLC__"